/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListAttribute } from '../../models/api-response-list-attribute';

export interface ListAttribute$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
}

export function listAttribute(http: HttpClient, rootUrl: string, params: ListAttribute$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListAttribute>> {
  const rb = new RequestBuilder(rootUrl, listAttribute.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListAttribute>;
    })
  );
}

listAttribute.PATH = '/v1/api/ui/referential/attribute/list';
